import ApplicationHeader from '@rio-cloud/rio-uikit/lib/es/ApplicationHeader';
import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { CustomFormattedMessage } from '../../i18n/i18n';
import { RioAppNavigatorDropdown } from './RioAppNavigatorDropdown';
import { UserMenu } from './UserMenu';
import { SupportMenu } from './SupportMenu';
import { appConfiguration } from '../../configuration/appConfiguration';
import {
  BOOKINGS_ROUTE,
  DASHBOARD_ROUTE,
  ONBOARDING_ROUTE,
  TRANSACTIONS_ROUTE,
} from '../../routes/routes';

export const Header = () => {
  const navItems: { key: string; route: ReactNode }[] = [
    {
      key: 'onboarding',
      route: (
        <NavLink to={ONBOARDING_ROUTE}>
          <CustomFormattedMessage
            id={'base.header.navigationLinks.onboarding'}
          />
        </NavLink>
      ),
    },
    {
      key: 'dashboard',
      route: (
        <NavLink to={DASHBOARD_ROUTE}>
          <CustomFormattedMessage
            id={'base.header.navigationLinks.dashboard'}
          />
        </NavLink>
      ),
    },
    {
      key: 'transactions',
      route: (
        <NavLink to={TRANSACTIONS_ROUTE}>
          <CustomFormattedMessage
            id={'base.header.navigationLinks.transactions'}
          />
        </NavLink>
      ),
    },
    {
      key: 'bookings',
      route: (
        <NavLink to={BOOKINGS_ROUTE}>
          <CustomFormattedMessage id={'base.header.navigationLinks.bookings'} />
        </NavLink>
      ),
    },
  ];

  return (
    <ApplicationHeader
      label={'MAN SimplePay'}
      appNavigator={<RioAppNavigatorDropdown />}
      homeRoute={
        <a
          href={appConfiguration.home.url}
          target="_top"
        />
      }
      navItems={navItems}
      actionBarItems={[
        <SupportMenu key="support-menu" />,
        <UserMenu key="user-menu" />,
      ]}
    />
  );
};
